addLeadingSlash